var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetricsMeasurments = function SvgMetricsMeasurments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.291 11.2V3.852L5.625 7.526zM5.625 21.813 24 43.505l18.375-21.692zm36.75-2.583L31.1 12.795H16.9L5.625 19.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.979 6.525h26.042v2H10.979z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.709 3.852V11.2l5.666-3.674z"
  })))));
};
export default SvgMetricsMeasurments;